import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import { useState, useEffect, useRef } from "react";
import { getCloset, getPreviousClosets } from "@utils/call-api/closets-call";
import CustomError from "@components/core/CustomError/CustomError";
import SharedAccountsLayout from "@components/core/SharedAccountsLayout";
import ProfileLayout from "@components/core/ProfileLayout";
import ClosetsView from "@components/views/Closets";

const Closets = () => {
  const [prevClosets, setPrevClosets] = useState([]);
  const [pagination, setPagination] = useState({});
  const [pageReady, setPageReady] = useState(false);
  const [error, setError] = useState(false);

  const controllerRef = useRef();

  async function fetchPreviousClosets(page) {
    const newController = new AbortController();
    controllerRef.current = newController;

    const previousClosets = await getPreviousClosets(newController, page);

    return previousClosets;
  }

  useEffect(() => {
    async function fetchInitData() {
      try {
        const previousClosets = await fetchPreviousClosets(1);

        setPrevClosets(previousClosets.data);
        setPagination(previousClosets.meta.pagination);
        setPageReady(true);
      } catch (err) {
        if (err.name !== "CanceledError") setError(err.response);
      }
    }

    fetchInitData();

    return () => {
      if (controllerRef.current) controllerRef.current.abort();
    };
  }, []);

  async function loadNextPage() {
    try {
      const res = await fetchPreviousClosets(pagination.next_page);
      setPrevClosets([...prevClosets, ...res.data]);
      setPagination(res.meta.pagination);
    } catch (err) {
      if (err.name !== "CanceledError") throw err;
    }
  }

  async function reloadPrevCloset(closetId) {
    const res = await getCloset(closetId);
    setPrevClosets((prev) => prev.map((closet) => (closet.id === closetId ? res : closet)));
  }

  if (error) return <CustomError statusCode={error.status} />;

  return (
    <>
      <SharedAccountsLayout
        title={"title_closets"}
        className="d-lg-none"
      />
      <ProfileLayout loading={!pageReady}>
        <ClosetsView
          prevClosets={prevClosets}
          loadNextPage={loadNextPage}
          allLoaded={pagination.current_page >= pagination.total_pages}
          reloadPrevCloset={reloadPrevCloset}
        />
      </ProfileLayout>
    </>
  );
};

export async function getServerSideProps({ params: { locale } }) {
  return {
    props: {
      headerBehaviors: { noFooter: true },
      ...(await getMessagesForNamespaces(locale, ["common", "closets", "accounts", "bal_modal"])),
    },
  };
}

export default Closets;
